<template>
    <cod-dialog
        class="select-order-item-comments"
        :show.sync="showDialog"
    >
        <!-- Header -->
        <template slot="header">
            <v-toolbar-title>
                {{ $t('general.comment') }}
            </v-toolbar-title>
        </template>

        <div class="pa-5" slot="content">
            <v-textarea
                v-model="comment"
                :label="$t('general.comment')"
                rows="2"
            />
        </div>

        <template slot="footer">
            <v-btn
                class="flex-1 mr-1"
                color="primary"
                outlined
                @click="showDialog = false"
            >
                {{ $t('general.close') }}
            </v-btn>

            <v-btn
                class="flex-1 ml-1"
                color="primary"
                depressed
                @click="save"
            >
                {{ $t('general.confirm') }}
            </v-btn>
        </template>
    </cod-dialog>
</template>

<script>
import CodDialog from '@/components/CodDialog';

export default {
    name: 'SelectOrderItemComments',

    components: {
        CodDialog,
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        orderItem: {
            type: Object,
            default: () => {}
        }
    },

    created() {
    },

    data: () => ({
        showDialog: false,
        comment: null,
    }),

    watch: {
        show(val) {
            this.showDialog = val;

            if(val) {
                this.$nextTick(() => {
                    this.comment = this.orderItem.comments.length ? this.orderItem.comments[0] : null
                })
            }
        },

        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    methods: {
        save() {
            this.showDialog = false

            this.$emit('save', {
                item: this.orderItem,
                comment: this.comment || null
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.select-order-item-comments {
}
</style>
